// extracted by mini-css-extract-plugin
export var container = "SkillCard-module--container--OGRVW";
export var images = "SkillCard-module--images--2i4eu";
export var imgWrapper = "SkillCard-module--imgWrapper--QcaAb";
export var text = "SkillCard-module--text--1jdcp";
export var title = "SkillCard-module--title--30oyD";
export var subtitle = "SkillCard-module--subtitle--1CknM";